import { useState, useEffect } from "react";
import isEmpty from "lodash/isEmpty";

/**
 * Данный маневр необходим что бы в билд старого стека не включался некст, так как там это бесполезно и работать не будет.
 * На уровне webpack.production.js добавляем next, next/router, next/link в исключения билда
 * Так как js в рантайме не найдет некст роутер, слушатели не будут навешены и хук вернет false
 * В nextjs все будет работать как и ожидается
 * Снести после того как все переедет в некст
 */
// eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires
const nextRouterModule = require("next/router");

let nextRouter: any;

if (!isEmpty(nextRouterModule)) {
  nextRouter = nextRouterModule;
}

type RouteChangeHandlerArgs = (
  url: string,
  options: { shallow?: boolean }
) => void;
export const useRouterLoading = (): boolean => {
  const [isLoading, setLoading] = useState(false);
  const router = isEmpty(nextRouterModule) ? {} : nextRouter?.useRouter();

  useEffect(() => {
    const handleRouteChange: RouteChangeHandlerArgs = (_url, options) => {
      if (!options?.shallow) {
        setLoading(true);
      }
    };

    const handleRouteComplete: RouteChangeHandlerArgs = (_url, _options) => {
      setLoading(false);
    };
    router?.events?.on("routeChangeStart", handleRouteChange);
    router?.events?.on("routeChangeComplete", handleRouteComplete);

    return () => {
      router?.events?.off("routeChangeStart", handleRouteChange);
      router?.events?.off("routeChangeComplete", handleRouteComplete);
    };
  }, []);

  return isLoading;
};
